exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card-charts[data-v-08d582a0] {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  border-radius: 12px;\n  box-shadow: -5px -5px 8px rgba(255, 255, 255, 1),\n    -2px -2px 12px rgba(255, 255, 255, 0.5),\n    inset 2px 2px 4px rgba(255, 255, 255, 0.1), 5px 5px 8px rgba(0, 0, 0, 0.15);\n}\n.sub-card-donut[data-v-08d582a0] { width: 35%; min-width: 250px;\n}\n", ""]);

// exports
